{
  "commentForm": {
    "placeholder": "Ajouter un commentaire"
  },
  "commentList": {
    "title": "Tous les commentaires"
  },
  "viewAllComments": "Afficher tous les commentaires",
  "edited": "Edité",
  "comment": "Commenter",
  "comments": "Commentaires",
  "moveComments": "Déplacer les commentaires ici",
  "showComments": "Afficher les commentaires",
  "hideComments": "Masquer les commentaires",
  "justNow": "Tout à l'heure",
  "deleteConfirmation": {
    "title": "Supprimer le commentaire",
    "description": "Êtes-vous sûr de vouloir supprimer ce commentaire ? Cette action ne peut pas être annulée."
  },
  "addComment": "Ajouter un commentaire",
  "cancelComment": "Annuler l'ajout d'un commentaire"
}